import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const NotificationIcon = ({ width = 20, height = 20, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.8178 18.5501C11.9314 18.842 10.9842 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 12.6738 17.834 15.0753 15.9828 16.7237"
          stroke="#102F3F"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.53418 8.4032H10.2761V13.629M8.53418 13.629H12.0181"
          stroke="#102F3F"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.9998 7.17917C10.4554 7.17917 10.8248 6.80981 10.8248 6.35417C10.8248 5.89854 10.4554 5.52917 9.9998 5.52917C9.54417 5.52917 9.1748 5.89854 9.1748 6.35417C9.1748 6.80981 9.54417 7.17917 9.9998 7.17917Z" 
          fill="#102F3F"
        />
    </svg>
  );
};
